// src/components/ACS-Dashboard/ACS-Blocks/GlobalPagination.js
import React from "react";
import PropTypes from "prop-types";
import PaginationBar from "./PaginationBar";

/**
 * Pagination for callers that know how many pages there are.
 *
 * Pass `totalItems` as well to get the "1–50 of 384" readout; without it the bar
 * shows the page and its total only.
 */
const GlobalPagination = ({
  label = "Items per page",
  currentPage,
  totalPages,
  totalItems,
  onPageChange,
  itemsPerPage,
  onItemsPerPageChange,
  options = [50, 100, 150],
}) => (
  <PaginationBar
    perPageLabel={label}
    perPage={itemsPerPage}
    perPageOptions={options}
    onPerPageChange={onItemsPerPageChange}
    currentPage={currentPage}
    totalPages={totalPages}
    totalItems={totalItems}
    onPageChange={onPageChange}
  />
);

GlobalPagination.propTypes = {
  label: PropTypes.string,
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  totalItems: PropTypes.number,
  onPageChange: PropTypes.func.isRequired,
  itemsPerPage: PropTypes.number,
  onItemsPerPageChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.number),
};

export default GlobalPagination;
